import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './de.json';
import en from './en.json';

export type Language = 'de' | 'en';
export const LANGUAGE_KEY = 'dispo.language';

const stored = localStorage.getItem(LANGUAGE_KEY);
const initial: Language = stored === 'en' ? 'en' : 'de';

void i18n.use(initReactI18next).init({
    resources: { de: { translation: de }, en: { translation: en } },
    lng: initial,
    fallbackLng: 'de',
    interpolation: { escapeValue: false },
});

export function setLanguage(language: Language): void {
    localStorage.setItem(LANGUAGE_KEY, language);
    void i18n.changeLanguage(language);
}

export default i18n;
